import React from "react";
import { Box, keyframes, Theme, useMediaQuery, useTheme } from "@mui/material";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
`;

interface DonutChartSkeletonProps {
  chartHeight: number;
}

export const DonutChartSkeleton = ({
  chartHeight,
}: DonutChartSkeletonProps) => {
  const theme = useTheme();
  const isXsDown = useMediaQuery((t: Theme) => t.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: chartHeight,
        height: chartHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: `${pulse} 1.5s ease-in-out infinite`,
      }}
    >
      <Box
        sx={{
          width: isXsDown ? 280 : 370,
          height: isXsDown ? 280 : 370,
          borderRadius: "50%",
          border: `${isXsDown ? 40 : 55}px solid`,
          borderColor: theme.palette.action.hover,
        }}
      />
    </Box>
  );
};
